import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import * as S from './AdImagesItem.styles';
import { RemoveRoundIcon, RotateRoundIcon } from '@/components/UI/Icons/Icons';
import { AdImagesItemProps } from '@/components/AdImages/AdImages.types';

export const AdImagesItem: React.FC<AdImagesItemProps> = ({
  image,
  onRemove,
  onItemClick,
  hasRotationControls,
  isSmall,
}) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: image.id });

  const style = isDragging
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: 0.7,
        zIndex: 1,
      }
    : {
        transform: CSS.Transform.toString(transform),
      };

  const [rotateAngle, setRotateAngle] = useState(0);

  function rotate(side: 'left' | 'right') {
    setRotateAngle(prev => (side === 'left' ? prev - 90 : prev + 90));
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <S.AdImagesItemBox $isSmall={isSmall}>
        <S.AdImagesImage
          src={image.src}
          alt=""
          $rotateAngle={rotateAngle}
          onClick={() => onItemClick?.(image.id)}
        />
        <S.AdImagesItemBtn
          $position="tr"
          hasPadding={false}
          appearance="transparent"
          onClick={() => onRemove(image.id)}
          $isSmall={isSmall}
        >
          <RemoveRoundIcon isFullOpacity={isSmall} />
        </S.AdImagesItemBtn>

        {hasRotationControls && (
          <>
            <S.AdImagesItemBtn
              $position="br"
              hasPadding={false}
              appearance="transparent"
              onClick={() => rotate('left')}
              $isSmall={isSmall}
            >
              <RotateRoundIcon />
            </S.AdImagesItemBtn>

            <S.AdImagesItemBtn
              $position="bl"
              hasPadding={false}
              appearance="transparent"
              onClick={() => rotate('right')}
              $isSmall={isSmall}
              $isMirrored
            >
              <RotateRoundIcon />
            </S.AdImagesItemBtn>
          </>
        )}
      </S.AdImagesItemBox>
    </div>
  );
};

AdImagesItem.displayName = 'AdImagesItem';
